import $ from 'jquery';
import Swiper from '../componenets/swiper';
import Clouds from '../componenets/clouds';
import Helper from '../utils/helper';
import Tracking from '../utils/tracking';

export default class Gallery {
    constructor() {
        this.$body = $('body');
        this.$gallery = $('.gallery-container');
        this.state = null;
        this.swiper = null;
        this.data = null;
        this.backgroundLeft = 0;
        this.backgroundTop = 0;
        this.isDesktop = !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (this.isDesktop) {
            this.clouds = new Clouds();
        }

        this.setEvents();

        window.addEventListener('popstate', () => {
            let paths = this.getPathValues();

            switch (paths.length) {
                case 1:
                    this.hide();
                    break;
                case 4:
                    if (!this.swiper) {
                        this.show(paths[1]);
                    }
                    break;
                default:
                    break;
            }
        });
    }

    getPathValues() {
        let pathArray = window.location.pathname.slice(1).split('/');
        return pathArray;
    }

    setEvents() {
        this.$body.find('.gallery__close').on('click', this.hide.bind(this));
        document.onkeydown = this.escapeOut.bind(this);
    }

    show(state, slide) {
        this.state = state;

        this.getData(() => {
            if (slide > 1) {
                this.swiper.slideTo(slide - 1);
            }
        });
    }

    disableBackgroundScroll() {
        if (!this.isDesktop) {
            let doc = document.documentElement;

            this.backgroundLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
            this.backgroundTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        }

        $('body').addClass('no-scroll');
    }

    enableBackgroundScroll() {
        if (!this.isDesktop) {
            window.scrollTo(this.backgroundLeft, this.backgroundTop);
        }

        $('body').removeClass('no-scroll');
    }

    hide() {
        if (this.clouds) {
            this.clouds.hide();
        }

        this.animateOut();

        this.swiper.destroy();
        this.swiper = null;
        this.enableBackgroundScroll();

        setTimeout(() => {
            let url_ref = window.location.href;

            $('.gallery-container .gallery').remove();
            window.history.pushState(null, null, '/');

            Tracking.comscore(window.location.href);

            Tracking.track({
                hitType: 'pageview',
                page: window.location.pathname
            });

            Tracking.parsely({
                url: window.location.href,
                urlref: url_ref
            });
        }, 300);
    }

    escapeOut(event) {
        event = event || window.event;
        let isEscape = false;

        if ('key' in event) {
            isEscape = event.key == 'Escape';
        } else {
            isEscape = event.keyCode == 27;
        }

        if (isEscape) {
            this.hide();
        }
    }

    animateIn() {
        this.$gallery.css('display', 'flex');
        this.$gallery.animate({
            opacity: 1
        });
        this.setSwiper();
    }

    animateOut() {
        this.$body.find('.gallery-container').fadeOut(function() {
            $(this).removeAttr('style');
        });
    }

    getData(cb) {
        $.ajax({
            url: `/woman/${this.state}/`
        }).then((data) => {
            this.data = data;
            this.$gallery.append(this.setGalleryHtml());

            if (this.clouds) {
                this.clouds.show(this.animateIn.bind(this));
            } else {
                this.animateIn();
            }

            if (cb) {
                return cb;
            }
        });
    }

    shareOnFacebook(event) {
        Tracking.track({
            hitType : 'social',
            socialNetwork : 'Facebook',
            socialAction : 'share',
            socialTarget : window.location.href
        });

        Helper.openToNewWindow(event, 580, 352);
    }

    shareOnTwitter(event) {
        Tracking.track({
            hitType : 'social',
            socialNetwork : 'Twitter',
            socialAction : 'tweet',
            socialTarget : window.location.href
        });

        Helper.openToNewWindow(event, 520, 550);
    }

    shareOnGooglePlus(event) {
        Tracking.track({
            hitType : 'social',
            socialNetwork : 'Google +',
            socialAction : 'share',
            socialTarget : window.location.href
        });

        Helper.openToNewWindow(event, 600, 600);
    }

    setGalleryHtml() {
        let images = this.renderSlides();

        return `
            <section class="gallery">
                <div class="gallery__states-container swiper-container">
                    <ul class="gallery__states swiper-wrapper">
                        ${images}
                    </ul>
                    <a href="#" class="gallery__arrow gallery__arrow--next">Next</a>
                    <a href="#" class="gallery__arrow gallery__arrow--prev">Prev</a>
                </div>
                <div class="gallery__info">
                    <h2 class="gallery__name">${this.data.woman.name}</h2>
                    <h3 class="gallery__instagram-username">
                        <a href="${this.data.woman.instagram_link}" target="_blank">${this.data.woman.instagram}</a>
                    </h3>

                    <div class="social social--gallery">
                        <a class="social__facebook" href="" ></a>
                        <a class="social__twitter" href="" ></a>
                        <a class="social__google_plus" href="" ></a>
                    </div>

                    <div class="gallery__blurb">
                        ${this.data.woman.description}
                    </div>
                    <div class="gallery__details">
                        ${this.data.woman.stat}
                    </div>
                </div>
            </section>
        `;
    }

    renderSlides() {
        let { svg_height, svg_width } = this.data.state,
            slides = [],
            i = 1;

        this.data.images.forEach((img) => {
            let { image, image_height, image_width, image_x, image_y } = img;

            slides.push(`
                <li class="gallery__state swiper-slide" data-history="${i++}">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 ${svg_width} ${svg_height}">
                        <image xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${image}" clip-path="url(#${this.state}-cp)" width="${image_width}" height="${image_height}" x="${image_x}" y="${image_y}"></image>
                    </svg>
                </li>
            `);
        });

        return slides.join('');
    }

    updateSocial(url) {
        let twitter_text = `${this.data.woman.name}. She's one of our 50 must-follows on Instagram.`,
            facebook_url = `http://www.facebook.com/sharer/sharer.php?u=${url}`,
            twitter_url = `https://twitter.com/intent/tweet?url=${url}&text=${twitter_text}&hashtags=americathebeautiful&related=UrbanDaddy,UrbanDaddy`,
            google_plus_url = `https://plus.google.com/share?url=${url}`;

        this.$facebook.attr('href', encodeURI(facebook_url));
        this.$twitter.attr('href', encodeURI(twitter_url));
        this.$googlePlus.attr('href', encodeURI(google_plus_url));
    }

    setSwiper() {
        this.$facebook = this.$body.find('.social--gallery .social__facebook');
        this.$twitter = this.$body.find('.social--gallery .social__twitter');
        this.$googlePlus = this.$body.find('.social--gallery .social__google_plus');

        this.swiper = new Swiper('.swiper-container', {
            effect: 'fade',
            history: 'slide',
            loop: 'true',
            fade: {
                crossFade: true
            },
            nextButton: '.gallery__arrow--next',
            prevButton: '.gallery__arrow--prev',
            keyboardControl: true,
            onInit: () => {
                // A hack to fix SVG not rendering on gallery in FF.
                if (Helper.isFireFox()) {
                    this.$body.find('.gallery__state').css('opacity', 1);
                }

                setTimeout(()=> {
                    this.updateSocial(window.location.href);

                    Tracking.track({
                        hitType: 'pageview',
                        page: window.location.pathname
                    });

                    Tracking.parsely({
                        url: window.location.href,
                        urlref: window.location.origin
                    });

                    Tracking.comscore(window.location.href);
                }, 100);
            },
            onSlideChangeEnd: (swiper) => {
                setTimeout(()=> {
                    let location_pathname = window.location.pathname.slice(0, -1) + swiper.previousIndex,
                        parsely_urlref = `${window.location.protocol}//${window.location.host}${location_pathname}`;

                    this.updateSocial(window.location.href);

                    Tracking.track({
                        hitType: 'pageview',
                        page: window.location.pathname
                    });

                    if (window.location.href !== parsely_urlref) {
                        Tracking.parsely({
                            url: window.location.href,
                            urlref: parsely_urlref
                        });
                    }

                    Tracking.comscore(window.location.href);
                }, 100);
            }
        });

        this.disableBackgroundScroll();

        this.$facebook.on('click', this.shareOnFacebook.bind(this));
        this.$twitter.on('click', this.shareOnTwitter.bind(this));
        this.$googlePlus.on('click', this.shareOnGooglePlus.bind(this));
    }
}



/** WEBPACK FOOTER **
 ** ./frontend/js/views/gallery.js
 **/